import { CustomMenuItem } from '../../commons/components/GrowegyMenu';
import { DownloadOnAppStoreBanner } from './DownloadOnAppStoreBanner';

export const createAppStoreMenuItem = (
  isHidden: boolean,
  onClick: () => void,
  dataTest?: string
): CustomMenuItem => ({
  type: 'custom',
  isHidden,
  dataTest,
  component: () => <DownloadOnAppStoreBanner onClick={onClick} />,
});
